import { useContext } from "react";
import type { LastBotCore } from "../core/LastBotCore";
import { CoreContext } from "./CoreContext";

export const useCore = (): LastBotCore => {
  const core = useContext(CoreContext);
  if (!core) {
    throw new Error("useCore must be used inside <CoreProvider>");
  }
  return core;
};
